import { MESSAGE_TYPE } from '../types';
import { UserMessage, UserMessageRequiredProps } from './UserMessage';

export const Message = ({
  type,
  uuid,
  props,
  isReadIt
}: {
  type: MESSAGE_TYPE;
  props: unknown;
  uuid: string;
  isReadIt?: boolean;
}) => {
  if (type === 'USER_MESSAGE') {
    // вот тут компонент UserMessage
    return <UserMessage id={uuid} isReadIt={isReadIt} {...(props as UserMessageRequiredProps)} />;
  }

  return null;
  // дальше условия для других компонентов-сообщений
};
